import { __assign, __read, __rest } from "tslib";
import React, { createContext, useRef, useState, useContext, forwardRef, } from "react";
import classNames from "classnames";
import { useConfig } from "../../../_util/config-context";
import { mergeRefs } from "../../../_util/merge-refs";
/**
 * 拖拽 Context 实例
 */
export var ResizeContext = createContext({});
ResizeContext.displayName = "Resizable";
export function ResizableTable(_a) {
    var table = _a.table, columns = _a.columns, props = __rest(_a, ["table", "columns"]);
    var wrapperRef = useRef(null);
    var lineRef = useRef(null);
    var headRef = useRef(null);
    var _b = __read(useState(false), 2), isResizing = _b[0], setIsResizing = _b[1];
    var classPrefix = useConfig().classPrefix;
    var resizeContext = {
        wrapperRef: wrapperRef,
        lineRef: lineRef,
        columns: columns,
        classPrefix: classPrefix,
        headRef: headRef,
        isResizing: isResizing,
        setIsResizing: setIsResizing,
        setHeadRef: function (element) {
            headRef.current = element;
        },
    };
    return (React.createElement(ResizeContext.Provider, { value: resizeContext }, React.cloneElement(table, __assign(__assign({}, props), { className: classNames(table.props.className, classPrefix + "-table--resizeable", props.className // eslint-disable-line
        ), children: (React.createElement("div", { style: { position: "relative", overflow: "auto" }, ref: wrapperRef },
            React.createElement("div", { ref: lineRef, style: {
                    position: "absolute",
                    top: 0,
                    left: "0px",
                    height: "100%",
                    backgroundColor: "#e7eaef",
                    width: "1px",
                    zIndex: 500,
                    display: "none",
                } }),
            table.props.children)) }))));
}
export var ResizableTableHead = forwardRef(function (_a, ref) {
    var head = _a.head, props = __rest(_a, ["head"]);
    var setHeadRef = useContext(ResizeContext).setHeadRef;
    return React.cloneElement(head, __assign(__assign({}, props), { ref: mergeRefs(head.ref, ref, setHeadRef) }));
});
ResizableTable.displayName = "ResizableTable";
//# sourceMappingURL=ResizableTable.js.map